import { IApplicationState } from '../../types/redux';
import { selectOffer } from '../offers';

export const selectSiteBlockIdByOfferId = (id: number) => (state: IApplicationState) => {
  const { contacts } = selectOffer(id)(state);

  return contacts.dynamicCalltracking.siteBlockId;
};
